export default __webpack_public_path__ + "static/media/checkout-success.57177350.svg";